import '../styles/Inscription.css';
import logo_kdo from '../assets/logo-kdo.png';
import Banner from '../components/Banner';
import Footer from '../components/Footer';
import GoogleLoginButton from './GoogleLoginButton';
import FacebookLoginButton from './FacebookLoginButton';
import { useState } from 'react'

function Inscription() {
  const [emailValue, setEmailValue] = useState('')
  const [nomValue, setNomValue] = useState('')
  const [isDataRegistering, setIsDataRegistering] = useState(false)
  const [isCompleted, setIsCompleted] = useState(false)
  const [isError, setError] = useState(false)
  const [tmpKey, setTmpKey] = useState('')

  if (tmpKey === '') {
    const timestamp = Date.now();
    setTmpKey(timestamp);
    console.log("timestamp " + tmpKey);
  }

  console.log(isCompleted);

  async function registerInscription(p_email) {

    console.log("registerEmail debut");
    const requestOptions = {
      method: "POST",
      mode: 'cors',
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        email: p_email,
        source: "requestInscription"
      }),
    };

    try {
      let v_responseJson = {};
      console.log("tmpKey " + tmpKey);
      setIsDataRegistering(true)
      const response = await fetch("https://app.listaki.fr/api/WS/addEmail.php?key=" + tmpKey, requestOptions)
      if (response.ok) {
        v_responseJson = await response.json();
        console.log("Reponse api debut");
        console.log(v_responseJson)
        console.log("Reponse api fin");
        setIsCompleted(true);
      } else {
        console.log("Erreur lors de l'appel à l'API");
        setError(true);
      }
    } catch (err) {
      console.log(err)
    } finally {
      setIsDataRegistering(false)
    }
  };

  async function createUser(p_nom, p_email) {
    console.log("createUser debut", p_nom, p_email);
    const requestOptions = {
      method: "POST",
      mode: 'cors',
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        email: p_email,
        name: p_nom
      }),
    };

    try {
      let v_responseJson = {};
      setIsDataRegistering(true)
      const response = await fetch("https://app.listaki.fr/api/WS/email-login.php?key=" + tmpKey, requestOptions)
      if (response.ok) {
        v_responseJson = await response.json();
        console.log("Reponse api debut");
        console.log(v_responseJson)
        console.log("Reponse api fin");
        if (v_responseJson["success"]) setIsCompleted(true)
        else alert(v_responseJson["error"])
      } else {
        console.log("Erreur lors de l'appel à l'API");
        v_responseJson = await response.json();
        if (v_responseJson["error"]) alert(v_responseJson["error"])
        setError(true);
      }
    } catch (err) {
      console.log(err)
    } finally {
      setIsDataRegistering(false)
    }
  }

  function isValidEmail(p_email) {
    console.log(p_email);
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(p_email);
  }

  function requestInscription() {
    if (isValidEmail(emailValue) && nomValue !== '') {
      // registerInscription(emailValue);
      createUser(nomValue, emailValue);
      if (window.umami) window.umami.track('requestInscription');
    }
    else {
      alert("Attention, ceci n'est pas une adresse valide 😥")
    }
  }

  function handleInputNom(e) {
    setNomValue(e.target.value)
  }

  function handleInputEmail(e) {
    setEmailValue(e.target.value)
  }

  return <div>
    <Banner>
      <span className='kdo-ban-logo'><a href="/" alt="Accueil"><img src={logo_kdo} alt='Mes Listes' className='kdo-ban-logo' /></a></span>
      <h1 className='kdo-ban-title'>LISTAKI : Crée ta liste !</h1>
    </Banner>
    {!isCompleted ? (
      <div className="kdo-reg-container">
        <p className="kdo-reg-title">Une plateforme simple et pratique pour enregistrer, organiser et partager toutes tes idées cadeaux.</p>
        <p> L'inscription via connexion mail est maintenant disponible.</p>
        <p> Laissez nous votre Nom et e-mail et nous vous enverrons par mail un lien de connexion à la version Béta.</p>
        <input
          className='kdo-reg-elem'
          placeholder='Nom ou pseudo'
          onChange={handleInputNom}
        />
        <input
          className='kdo-reg-elem'
          placeholder='Entrez votre mail'
          onChange={handleInputEmail}
        />
        <button className="kdo-reg-button" onClick={() => {
                          if (window.umami) window.umami.track('requestInscription');
                          requestInscription();
                        }}
                disabled={isDataRegistering}>{isDataRegistering ? "Inscription en cours..." : "Inscription à la Béta"}</button>
        <p>&nbsp;</p>
        <p>Sinon utilisez un autre moyen d'inscription pour créer votre compte dès maintenant.</p>
        <div className="google-button-wrapper">
          <GoogleLoginButton />
        </div>
        <div className="kdo-fb">
          <FacebookLoginButton />
        </div>
      </div>
    ) : (
      <div className="kdo-reg-container">
        <p className="kdo-reg-title">Une plateforme simple et pratique pour enregistrer, organiser et partager toutes tes idées cadeaux.</p>
        <p>Votre inscription à la version Béta a bien été enregistrée.</p>
        <p>Un email de confirmation contenant votre lien de connexion vient de vous être envoyé, vérifiez vos spams et ajoutez le à vos listes de contactes pour que le prochain mail vous arrive directement.</p>
        <p>Merci !</p>
        <a href="/" alt="Accueil">Retour à l'accueil</a>
      </div>
    )}
    <Footer />
  </div>
}

export default Inscription